const others = [
   {
    name: 'Tag',
    description: 'Tondo Light / Font Size: 14px / Line-Height: 21px / Spacing: 0.1',
    className: '.tag',
    type: 'others',
    rows: 1,
    items: ['Lorem ipsum dolor sit amet'],
  },
  {
    name: 'Nav',
    description: 'Tondo Light / Font Size: 12px / Line-Height: 14px / Spacing: 0.8 / Uppercase',
    className: 'nav',
    type: 'others',
    rows: 1,
    items: ['Lorem ipsum dolor sit amet'],
  },
   {
    name: 'Label',
    description: 'Tondo Light / Font Size: 11px / Line-Height: 14px / Spacing: 0.8 / Uppercase',
    className: 'label',
    type: 'others',
    rows: 1,
    items: ['Lorem ipsum dolor sit amet'],
  },
];

export default others;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/constants/others.js